import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import AnalyticsChartWrapper from './AnalyticsChartWrapper';
import classes from '../analytics.module.scss';
import { ReactComponent as DownIcon } from '../../../../../assets/icons/down.svg';
import { ReactComponent as UpIcon } from '../../../../../assets/icons/up.svg';
import { getContactedRequest } from '../../../../../store/actions/possiblePersons';
import Loader from '../../../../_common/Loader/Loader';
import { useQuery } from '../../../../../utils/hooks/useQuery';

const chartTemplate = {
  series: [],
  options: {
    chart: {
      type: 'area',
      toolbar: false,
      sparkline: {
        enabled: true,
      },

    },
    title: {
      text: '_',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 24,
      floating: false,
      style: {
        fontSize: '44px',
        fontWeight: 700,
        color: 'transparent',
        opacity: 0,
      },
    },
    colors: ['#0B3DEF'],

    dataLabels: {
      enabled: false,
    },

    fill: {
      colors: '#FFFFFF',
      opacity: 1,
      type: 'gradient',
      gradient: {
        type: 'vertical',
        shadeIntensity: 0.5,
        gradientToColors: ['#0B3DEF', '#FFFFFF'],
        inverseColors: true,
        opacityFrom: 0.3,
        opacityTo: 1,
        stops: [0, 90, 100],
      },
    },

    tooltip: {
      style: {
        fontSize: '12px',
      },
      marker: {
        show: false,
      },
      x: {
        show: true,
      },
    },

    yaxis: {
      labels: {
        show: false,
      },
    },

    xaxis: {
      categories: [],
      labels: {
        show: false,
      },

      tooltip: {
        enabled: false,
      },
    },
  },

};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');

const Contacted = () => {
  const { query, setQuery } = useQuery();

  const {
    cntId, cntName, cntStart,
  } = query;

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [chart, setChart] = useState(chartTemplate);
  const [requestData, setRequestData] = useState({
    start: cntStart || thisMonthStartDay,
    healthPlanId: cntId || '',
    healthPlanName: cntName || '',
  });

  const {
    start, healthPlanId, healthPlanName,
  } = requestData;

  const [healthValue, setHealthValue] = useState(cntName || '');

  const [info, setInfo] = useState({});

  const changeDateAndHealth = (value, path, planName) => {
    setRequestData((prev) => {
      const newData = {
        ...prev,
        [path]: value,
      };

      if (path === 'healthPlanId') {
        newData.healthPlanName = planName;
      }

      return newData;
    });
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { payload: { data } } = await dispatch(getContactedRequest(requestData));
      setChart((prev) => ({
        ...prev,
        series: [{
          name: 'Contacted',
          data: data.daily.map((d) => d.count),
        }],
        options: {
          ...prev.options,
          xaxis: {
            ...prev.options.xaxis,
            categories: data.daily.map((d) => d.date),
          },
        },
      }
      ));

      setQuery({
        ...query, cntStart: start, cntId: healthPlanId, cntName: healthPlanName,
      });

      setInfo(data.data);
      setLoading(false);
    })();
  }, [requestData]);

  return (
    <AnalyticsChartWrapper
      chartWrapperClass="chart_wrapper"
      title="Contacted"
      calendarMonth
      date={requestData}
      healthValue={healthValue}
      setHealthValue={setHealthValue}
      onChange={changeDateAndHealth}
    >
      {loading
        ? <div className={classes.loader_wrapper}><Loader /></div>
        : !chart.options.xaxis.categories.length && !loading
          ? <div className={classes.notResult}>No Data Found</div>
          : (
            <>
              <Chart
                options={chart.options}
                series={chart.series}
                type="area"
                height={360}
                width="100%"
              />

              <div className={classes.chart_title}>
                <p className={classes.chart_title_count}>{info.totalCount}</p>

                <div className={classes.chart_title_percent}>
                  {info.sign ? <UpIcon /> : <DownIcon />}

                  <p>{`${info.percentage}%`}</p>
                </div>
              </div>
            </>
          )}
    </AnalyticsChartWrapper>
  );
};

export default Contacted;
